/**Dependencies */
import React, { useState, useEffect } from 'react';
import { Navigation } from 'swiper/modules';

/**Components */
import { CardsProducts } from '../components/CardsProducts';
import {  Col, Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap';
import { Swiper, SwiperSlide } from "swiper/react";

/* Services */
import {getProductsBySection, getFiltersBySection } from '../services/adminProductService';

/**Images */
import { IoIosArrowForward, IoIosArrowBack  } from "react-icons/io";
export const PromotionsList = ({isHome}) => {

    const [cardPromotions, setCardPromotions] = useState([]);
    const [filteredData, setFilteredData] = useState(cardPromotions);
    const [promotionsList, setPromotionsList] = useState([]);

    useEffect(() => {
        const fetchPromotions = async () => {
          try {
            const response = await getProductsBySection("PROM");
            setCardPromotions(response);
            setFilteredData(response);
          } catch (err) {
            console.error('Error al cargar las imágenes:', err);
          }
        };
        fetchPromotions();    
      }, []);

      useEffect(() => {
          const fetchPromotions = async () => {
            try {
              const response = await getFiltersBySection("PROM");    
                    
              setPromotionsList(response);
            } catch (err) {
              console.error('Error al cargar los filtros:', err);
            }
          };
      
          fetchPromotions();
          
        }, []);
    
      const handleFilter = (id) => {
        if (id !== 'All') {
            // Filtrar los datos que coincidan con el ID
            const filtered = cardPromotions.filter((item) => item.nombre === id);
            setFilteredData(filtered);
          } else {
            // Mostrar todos los datos originales
            setFilteredData(cardPromotions);
          }
      };

  return (
    <div>
        {!isHome &&
            <div className="container mt-4">
                <ButtonToolbar className="d-flex justify-content-center flex-wrap" id='filters-tours'>
                <ButtonGroup className="m-2 gap-3">
                    <Button className='btn-ligth' onClick={()=>handleFilter('All')} variant="primary">Todos</Button>
                    {promotionsList?.map((info, index) => (
                      <Button key={index+1} className='btn-ligth' onClick={()=>handleFilter(info.nombre)} variant="success">{info.nombre}</Button>  
                    ))}                                                            
                </ButtonGroup>
                </ButtonToolbar>
            </div>
        }
        <div className="slider-container carousel-container">           
          <div className="custom-prev" id='prev-promotions'><IoIosArrowBack/></div>    
            <Swiper
              navigation={{
                nextEl: '#next-promotions',
                prevEl: '#prev-promotions',
              }}
               modules={[Navigation]}
              spaceBetween={-10} 
              slidesPerView={1} 
              loop={true} 
              autoplay={{ delay: 3000 }}
              breakpoints={{
                  640: {
                  slidesPerView: 1,
                  
                  },
                  768: {
                  slidesPerView: 2,
                  
                  },
                  1024: {
                  slidesPerView: 3.5,
                  
                  },            
              }}
            >
              {filteredData.length > 0 && 
                  filteredData?.map((info, index) => (
                      <SwiperSlide key={index}>
                      <Col lg={3} md={6} sm={12} key={index+1} className='promociones-home'>
                          <CardsProducts infoCards={info} products={true}/>
                      </Col>
                      </SwiperSlide>
                  ))                
              }            
            </Swiper>
            <div className="custom-next" id='next-promotions'><IoIosArrowForward/></div>
        
        </div>
    </div>
  )
}
